import React from 'react';

import {ArrowLeftIcon, Button, SmallLoader} from '@kit';

import {getApolloError} from '../../components/utils';
import {useCharacterSheetQuery} from '../../generated/types';
import {CharacterEditor} from './character/character-editor';
import {CharacterWorkspace} from './character/character-workspace';
import type {CharacterState} from './character/model/character-state';

import css from './sheets.module.css';

type Props = {
	sheetId: string;
};

export const SheetView: React.FC<Props> = ({sheetId}) => {
	const {data, loading, error} = useCharacterSheetQuery({
		variables: {id: sheetId},
		ssr: false,
		fetchPolicy: 'network-only',
	});

	if (loading || (!data && !error)) {
		return (
			<div className={css.message}>
				<SmallLoader />
			</div>
		);
	}
	if (error || !data) {
		return (
			<div className={css.message}>
				<p>{error ? getApolloError(error).message : 'Бланк персонажа не найден.'}</p>
				<Button appearance="primary" icon={<ArrowLeftIcon />} route="sheets">
					Все персонажи
				</Button>
			</div>
		);
	}

	return (
		<CharacterEditor key={sheetId} sheetId={sheetId} initialState={data.characterSheet.data as CharacterState}>
			<CharacterWorkspace
				toolbar={
					<div className={css.sheetToolbar}>
						<Button appearance="subtle" icon={<ArrowLeftIcon />} route="sheets">
							Все персонажи
						</Button>
					</div>
				}
			/>
		</CharacterEditor>
	);
};
